module.exports = __webpack_public_path__ + "media/images/arrows/twisted/orange-down-36947172cfeb57590fc815002b541610.svg";